<template>
  <div class="resultados">
    <MsgErroFormularios v-if="erro && msgErros" :mensagens="msgErros" :erro="erro" @fechar-erro="fecharErro" />
    <table>
      <thead>
        <tr>
          <th>Órgão</th> 
          <th>Tipo</th> 
          <th>Nome</th>
          <th>Status</th>          
          <th class="th-observacao">Obs.</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(colegiado, index) in colegiadoFormat">
          <template>            
          <tr 
            :key="colegiado.id" 
            :class="[classesDeEstilo[index], 'linha-clicavel']"
            @click="abrirVisualizacao(colegiado)"
          >
            <td data-label="Orgão:" style="text-align: left;">
              <span>{{ formatarNomeProprio(colegiado.orgao_nome) }} — {{ colegiado.orgao_sigla ? colegiado.orgao_sigla.toUpperCase() : '' }}</span>
            </td>
            <td data-label="Tipo:" style="text-align: left;">
              <span>{{ formatarTipo(colegiado.tipo) }}</span>
            </td>
            <td data-label="Nome:" style="text-align: left;">
              <span>
                {{ formatarNomeProprio(colegiado.nome) }}
                <span v-if="colegiado.sigla"> — {{ colegiado.sigla.toUpperCase() }}</span>
              </span>
            </td>
            <td data-label="Status:" style="text-align: left;">
              <span class="status-badge" :class="'status-badge--' + (colegiado.status || '').toLowerCase().replace(' ', '-')">
              {{ formatarStatus(colegiado.status) }}
            </span>
            </td>
                        
            <td class="td-observacao" @click.stop>
              <span
                v-if="colegiado.observacao"
                class="icone-tabela icone-observacao"
                :title="linhasObservacaoAbertas[colegiado.id] ? 'Ocultar observação' : 'Exibir observação'"
                @click="toggleObservacao(colegiado.id)">
                <span v-if="linhasObservacaoAbertas[colegiado.id]">&#x25BC;&#xFE0E;</span>
                <span v-else>&#x25B6;&#xFE0E;</span>
              </span>
            </td>
              <div class="modal-exclusao" :id="colegiado.id">
                <div class="modal-mask">
                  <div class="modal-container">
                    <div class="modal-header">
                      <h2>Deseja mesmo excluir esse Colegiado?</h2>
                    </div>
                    <div class="modal-body">
                      <p>Dados do Colegiado:</p>
                      <div class="dados">
                        <div class="flexbox">
                          <div class="texto-centralizado">
                            Nome: <span>{{ colegiado.nome }}</span>
                          </div>
                          <div class="texto-centralizado">
                            Órgão: <span>{{ colegiado.orgao_id }}</span>
                          </div>
                          <div class="texto-centralizado">
                            Tipo: <span>{{ formatarTipo(colegiado.tipo) }}</span>
                          </div>
                          <div class="texto-centralizado">
                            Status: <span>{{ formatarStatus(colegiado.status) }}</span>
                          </div>
                        </div>
                        <div class="flexbox">
                            <div class="texto-centralizado">
                                Quantidade de membros titulares mínimo: <span>{{ colegiado.quantidade_membros_titulares_minimo }}</span>
                            </div>
                            <div class="texto-centralizado">
                                Quantidade de membros suplentes mínimo: <span>{{ colegiado.quantidade_membros_suplentes_minimo }}</span>
                            </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado">
                                Quantidade de membros titulares máximo: <span>{{ colegiado.quantidade_membros_titulares_maximo }}</span>
                            </div>
                            <div class="texto-centralizado">
                                Quantidade de membros suplentes máximo: <span>{{ colegiado.quantidade_membros_suplentes_maximo }}</span>
                            </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado">
                            Regimento Interno: <span>{{ colegiado.regimento_interno}}</span>
                          </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado">
                              Motivo do Status Inativo:
                              <span v-if="colegiado.status === 'inativo'">{{ colegiado.status_motivo }}</span>
                              <span v-else>Não disponível</span>
                          </div>
                          <div class="texto-centralizado">
                              Link do Motivo do Status Inativo:
                              <span v-if="colegiado.status === 'inativo'">{{ colegiado.status_link_motivo || 'Não disponível' }}</span>
                              <span v-else>Não disponível</span>
                          </div>
                        </div>
                        <div class="flexbox">
                            <div class="texto-centralizado">
                              Duração do mandato (anos): <span>{{ colegiado.duracao_mandato }}</span>
                            </div>
                            <div class="texto-centralizado">
                              Intervalo do mandato (anos): <span>{{ colegiado.intervalo_mandato }}</span>
                            </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado">
                            Remunerado: <span>{{ colegiado.remunerado ? 'Sim' : 'Não' }}</span>
                          </div>
                          <div class="texto-centralizado">
                            Valor Remunerado:
                            <span v-if="colegiado.valor_remunerado">{{ colegiado.valor_remunerado }}</span>
                            <span v-else>Não aplicado</span>
                          </div>
                          <div class="texto-centralizado">
                            Referendar Nome: <span>{{ colegiado.referendar_nome ? 'Sim' : 'Não' }}</span>
                          </div>
                          <div class="texto-centralizado">
                            Sabatina Alego: <span>{{ colegiado.sabatina_alego ? 'Sim' : 'Não' }}</span>
                          </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado">
                            Nomeação do Governador: <span>{{ colegiado.nomeacao_governador ? 'Sim' : 'Não' }}</span>
                          </div>
                          <div class="texto-centralizado">
                            Cargo de presidente nomeação em comissão: <span>{{ colegiado.cargo_presidente ? 'Sim' : 'Não' }}</span>
                          </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado ">
                            Lista Tríplice: <span>{{ colegiado.lista_triplice ? 'Sim' : 'Não' }}</span>
                          </div>
                          <div class="texto-centralizado">
                            Indicação do Governador: <span>{{ colegiado.indicacao_governador ? 'Sim' : 'Não' }}</span>
                          </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado ">
                            Permite Recondução: <span>{{ colegiado.permite_reconducao ? 'Sim' : 'Não' }}</span>
                          </div>
                          <div class="texto-centralizado">
                            Quantidade de recondução:
                              <span v-if="colegiado.permite_reconducao">{{ colegiado.quantidade_reconducao }}</span>
                              <span v-else>Não aplicado</span>
                          </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado ">
                            Legislação: <span>{{ colegiado.legislacao}}</span>
                          </div>
                          <div class="texto-centralizado">
                            Link Legislação:
                              <span v-if="colegiado.link_legislacao">{{ colegiado.link_legislacao }}</span>
                              <span v-else>Não disponível</span>
                          </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado ">
                            Representantes da sociedade civil organizada: <span>{{ colegiado.representantes_sociedade}}</span>
                          </div>
                        </div>
                        <div class="flexbox">
                          <div class="texto-centralizado">
                            Observação: <span>{{ colegiado.observacao}}</span>
                          </div>
                        </div>
                      </div>
                  </div>
                    <div class="modal-footer">
                      <button class="btn-confirmar-exclusao" @click="excluirLinha(colegiado.id)">Sim</button>
                      <button class="btn-cancelar-exclusao" @click="opcoesExcluir(colegiado.id)">Não</button>
                    </div>
                  </div>
                </div>
              </div>
            </tr>
            <tr v-if="linhasObservacaoAbertas[colegiado.id]" :key="`obs-${colegiado.id}`" class="linha-observacao">
              <td colspan="6">
                <div class="conteudo-observacao">
                  <b>Observações:</b>
                  <span>{{ colegiado.observacao }}</span>
                </div>
              </td>
            </tr>
          </template>
        </template>

        <tr v-if="!colegiados || colegiados.length === 0" class="sem-resultados">
          <p><b>Nenhum Resultado Encontrado</b></p>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import { parseISO, format } from "date-fns";
  import MsgErroFormularios from "../MsgErroFormularios";
  import ColegiadoApi from "../../services/ColegiadoApi";

  export default {
    name: "TabelaResultadosColegiado",
    props: {
      colegiados: Array,
      colegiado: Object,
      permissoes: Object,
    },
    components: {
      MsgErroFormularios,
    },
    created() {
      this.colegiadoApi = new ColegiadoApi();
    },
    data() {
      return {
        msgErros: {
          colegiado: "",
        },
        erro: false,
        linhasObservacaoAbertas: {},
        colegiadoFormat: this.colegiados.map((v) => {
          return {
            ...v,
          };
        }),
      };
    },
    computed: {
      classesDeEstilo() {
        if (!this.colegiadoFormat || this.colegiadoFormat.length === 0) return [];

        return this.colegiadoFormat.map((_, index) => {
          return index % 2 === 0 ? 'linha-cinza' : '';
        });
      }
    },
    methods: {
      abrirVisualizacao(colegiado) {
        if (!colegiado?.id) return;
        this.$router.push({
          name: "ColegiadoShow",
          params: { id: colegiado.id },
        });
      },
      toggleObservacao(id) {
        this.$set(this.linhasObservacaoAbertas, id, !this.linhasObservacaoAbertas[id]);
      },
      formatarNomeProprio(texto) {
        if (!texto) return '';
        
        const excecoesMinusculas = ['de', 'da', 'do', 'das', 'dos', 'e'];
        
        const siglasConhecidas = [
          'AGR', 'ALEGO', 'SANEAGO', 'DETRAN', 'SGU', 'SISCOL', 'GOINFRA', 
          'CPF', 'RG', 'GO', 'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
        ];
        
        return texto
          .toString()
          .toLowerCase()
          .split(' ')
          .map(palavra => {
            const palavraLimpa = palavra.replace(/[()]/g, '').toUpperCase();
  
            // 1. Ainda reconhece caracteres maiúsculos
            if (siglasConhecidas.includes(palavraLimpa)) {
              return palavra.toUpperCase();
            }
  
            // 2. Manter as preposições com letras minúsculas
            if (excecoesMinusculas.includes(palavra)) {
              return palavra;
            }
  
            // 3. Deixa a primeira letra maiúscula
            return palavra.charAt(0).toUpperCase() + palavra.slice(1);
          })
          .join(' ');
      },
      opcoesExcluir(colegiadoId) {
        let modalExclusao = document.getElementsByClassName("modal-exclusao");

        for (let i = 0; i < modalExclusao.length; i++) {
          if (modalExclusao[i].id == colegiadoId) {
            if (modalExclusao[i].style.visibility !== "visible") {
              modalExclusao[i].style.visibility = "visible";
            } else {
              modalExclusao[i].style.visibility = "hidden";
            }
          }
        }
      },
      formatarStatus(valor) {
          if (valor === 'em_estruturacao') {
              return 'Em estruturação';
          } else if (valor === 'ativo') {
              return 'Ativo';
          } else if (valor === 'inativo') {
              return 'Inativo';
          }

          return valor; 
      },
      formatarTipo(valor) {
        if (valor === 'conselho') {
          return 'Conselho';
        } else if (valor === 'comite') {
          return 'Comitê';
        } else if (valor === 'forum') {
          return 'Fórum';
        } else if (valor === 'diretoria') {
          return 'Diretoria';
        } else if (valor === 'camara') {
          return 'Câmara';
        }else if (valor === 'colegio') {
          return 'Colégio';
        }else if (valor === 'junta') {
          return 'Junta';
        }

        return valor; 
      },

      async excluirLinha(colegiadoId) {
        this.opcoesExcluir(colegiadoId);

        try {
          this.carregando = true;
          this.erro = false;

          if (this.colegiadoApi.cancelTokens.destroyColegiado) {
            this.colegiadoApi.cancelTokens.destroyColegiado.cancel();
          }

          await this.colegiadoApi.destroyColegiado(colegiadoId);
          window.location.reload();
        } catch (err) {
          if (this.colegiadoApi.isCancel(err)) {
            return;
          }

          this.carregando = false;
          this.erro = true;

          this.msgErros.colegiado =
            "Não foi possível excluir este colegiado, pois ele está vinculado a alguma outra entidade.";
        }
      },
      formatarData: function (value) {
        if (value == null) {
          return;
        }
        return format(parseISO(value), "dd/MM/yyyy");
      },
      formatarDataParaComparacao(value) {
        let newValue = new Date(value);
        let timeToCompare = newValue.getTime();
        return timeToCompare;
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "../../assets/stylesheets/TabelaResultadosBase.scss";

.resultados > table {
  margin-top: 1.35rem;
  background: #ededed;
  border: 1px solid #dde5e0;
  border-radius: 0.85rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05), 0 10px 28px rgba(0, 0, 0, 0.08);
  width: 100%;
  border-collapse: separate; 
  border-spacing: 0;
  overflow: hidden;
}

/* Estilos de Célula e Cabeçalho (Fonte Karla, Cores SGU)  */

th, td {
  border: none !important;
  border-bottom: 1px solid #eeeae7 !important;
  padding: 0.75rem 0.85rem;
  vertical-align: middle;
  font-size: 0.95rem;
  color: #1f2d24;
  font-family: "Karla", sans-serif;
  background: transparent;
  border-radius: 0 !important;
}

/* Remove a borda inferior da última linha para não chocar com o border-radius */
tbody tr:last-child td {
  border-bottom: none !important;
}

/* Estilização do cabeçalho Padrão SGU */
thead th {
  background: #ededed !important;
  color: #005516 !important;
  font-family: "Karla", sans-serif;
  font-size: 0.95rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  line-height: 1.25;
  border-bottom: 1px solid #d5e2d9 !important;
  border-right: 1px solid #a6c9b1 !important;
  padding-top: 0.85rem;
  padding-bottom: 0.85rem;
  text-align: left;
}

thead th:last-child {
  border-right: none !important;
}

/* Efeito Zebrado e Hover Integrado   */

tbody tr {
  transition: background-color 0.15s ease;
}

/* Linha Cinza Suave para contrastar */
tbody tr.linha-cinza {
  background-color: #ffffff !important;
}

.linha-clicavel {
  cursor: pointer;
}

/* Hover na cor verde institucional */
tbody tr.linha-clicavel:hover {
  background-color: rgba(0, 85, 22, 0.05) !important;
}

/* Badges de Status Modernos (Adaptado da TabelaResultadosCategoria) */

.status-badge {
  display: inline-block;
  padding: 0.25rem 0.75rem;
  border-radius: 999px; /* Formato Pílula */
  font-size: 0.75rem;
  font-family: "Karla", sans-serif;
  font-weight: 700;
  line-height: 1.25;
  text-align: center;
  white-space: nowrap;
}

.status-badge--ativo {
  background: rgba(0, 85, 22, 0.12);
  color: #005516;
}

.status-badge--inativo {
  background: rgba(180, 40, 40, 0.1);
  color: #9b2c2c;
}

.status-badge--em-estruturação, /* Apanha variações comuns */
.status-badge--em_estruturacao {
  background: rgba(47, 84, 150, 0.12);
  color: #2f5496;
}

/* Linha de Observação (Expandir / Recolher) */

.th-observacao,
.td-observacao {
  width: 3rem !important;
  text-align: center !important;
  vertical-align: middle !important;
  padding: 0 !important;
}

.icone-observacao {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: transparent !important; 
  border: none !important;
  padding: 0.2rem;
}

.icone-observacao span {
  color: #005516 !important;
  font-size: 1.1rem !important;
  display: inline-block;
  line-height: 1;
}

.linha-observacao {
  background-color: #f7faf8 !important;
}

.linha-observacao td {
  text-align: left !important;
  border-top: none !important;
  padding: 0 !important;
}

.conteudo-observacao {
  padding: 0.8rem 1.5rem !important;
  font-size: 0.9rem !important;
  color: #3d4d44 !important;
  border-left: 4px solid #005516; 
  font-family: "Karla", sans-serif;
}

.conteudo-observacao b {
  color: #005516 !important;
  margin-right: 0.4rem !important;
}

/* Tabela Vazia (Sem Resultados)  */

.sem-resultados td {
  text-align: center;
  padding: 2.5rem !important;
}

.sem-resultados p b {
  color: #5f6f66;
  font-family: "Karla", sans-serif;
  font-size: 1rem;
  font-weight: normal;
}

/* Modal de Exclusão (Estrutura intocada e polida para o padrão Karla)        */

.modal-exclusao {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: none;
  transition: opacity 0.3s ease;
  
  &.visible {
    display: table !important;
  }

  .modal-mask {
    border-radius: 1rem;
    position: relative;
    z-index: 1001;
    top: 5vh; /* Ajustado para dar mais espaço vertical */
    width: 70vw; /* Alargado para caber o grid */
    max-height: 90vh; /* Impede que fuja da tela */
    overflow-y: auto; /* Permite scroll se for muito alto */
    background-color: #f2f2f2;
    margin: 0 auto;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  }

  .modal-container {
    padding: 1.2rem;
    font-family: "Karla", sans-serif;
    
    .modal-header h2 {
      font-size: 1.2rem;
      font-family: "Karla", sans-serif;
      font-weight: 700;
      color: #1f2d24;
      margin-bottom: 1rem;
    }

    .modal-body {
      border: 1px solid #dde5e0;
      border-radius: 0.75rem;
      background: #ffffff;
      padding: 1rem;
      text-align: left;
      
      p {
        font-family: "Karla", sans-serif;
        font-weight: 700;
        font-size: 0.95rem;
        margin-bottom: 0.75rem;
        color: #005516;
      }

      .dados {
        font-size: 0.9rem;
        line-height: 1.5;
        
        .flexbox {
          display: grid;
          grid-template-columns: 1fr 1fr; /* Coloca os dados em duas colunas no modal */
          gap: 0.5rem;
          margin-bottom: 0.5rem;
        }

        .texto-centralizado {
          font-family: "Karla", sans-serif;
          font-weight: 700;
          color: #1f2d24;
          
          span {
            font-weight: normal;
            color: #4a5a50;
            margin-left: 0.25rem;
          }
        }
      }
    }
  }

  .modal-footer {
    margin-top: 1rem;
    display: flex;
    justify-content: space-evenly;
    
    button {
      border: none;
      border-radius: 2rem;
      width: 35%;
      height: 2.2rem;
      font-family: "Karla", sans-serif;
      font-weight: 700;
      font-size: 0.9rem;
      cursor: pointer;
      transition: transform 0.1s ease, filter 0.15s ease;
      
      &:hover { filter: brightness(0.9); }
      &:active { transform: scale(0.97); }
    }

    .btn-confirmar-exclusao { background-color: #005516; color: #f2f2f2; }
    .btn-cancelar-exclusao { background-color: #bd0000; color: #f2f2f2; }
  }
}

/* ========================================================================== */
/* Responsividade                                                             */
/* ========================================================================== */
@media screen and (min-width: 1066px) {
  tbody tr td:nth-child(1) { min-width: 12rem; text-align: left; }
  tbody tr td:nth-child(2) { min-width: 8rem; text-align: left; }
  tbody tr td:nth-child(3) { text-align: left; }
  tbody tr td:nth-child(4) { min-width: 10rem; text-align: left; }
}

@media screen and (max-width: 768px) {
  .modal-exclusao .modal-mask { width: 95% !important; }
  .modal-exclusao .modal-container .modal-body .dados .flexbox {
    grid-template-columns: 1fr; /* Coluna única em telas pequenas */
  }
}
</style>